<script setup lang="ts">
import type { Article } from '#shared/interfaces/pickup/article'

const { post } = defineProps<{ post: Article }>()

function existsImage(path?: string): string {
  if (!path || path.endsWith('undefined')) {
    return '/icon/nophoto_big.jpg'
  }
  return path
}
</script>
<template>
  <div class="content">
    <div class="image">
      <img
        onerror="
          this.src = 'https://img.goo-net.com/goo/usedcar/nophoto_big.jpg'
        "
        class="icon-article"
        :src="existsImage(post.thumbnail_path)"
        loading="lazy"
      />
    </div>
    <div class="text-area">
      <div class="text-category">
        {{ post.category_name }}
      </div>
      <span class="text-date">{{ post.post_date.substring(0, 10) }} UP</span>
      <div class="text-title">
        {{ post.title }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.content {
  display: flex;
  padding: 16px;
}
.icon-article {
  width: 122px;
  height: 91px;
  border-radius: 10%;
  vertical-align: middle;
  object-fit: cover;
}
.text-area {
  margin-left: 16px;
}
.text-category {
  display: flex;
  min-height: 23px;
  width: fit-content;
  border: 1px solid #ecf0f2;
  font-size: 11px;
  padding-left: 6px;
  padding-right: 6px;
  margin-bottom: 4px;
  align-items: center;
}
.text-date {
  font-size: 12px;
  opacity: 40%;
}
.text-title {
  font-size: 15px;
}
</style>
